import { VARIANT_NO_FLY, ZoneVariant } from "@src/features/zones/pages/zones-page/types";
import React from "react";
import ZoneDetailsPopupNoFly from "./no-fly";
import ZoneDetailsPopupSafeLand from "./safe-land";
import { ZoneEntity } from '@src/core/features';

export interface ZoneDetailsPopupProps {
  zone: ZoneEntity;
  variant: ZoneVariant;
}

export const ZoneDetailsPopup: React.FC<ZoneDetailsPopupProps> = (props) => {
  const { zone = {} as ZoneEntity, variant = VARIANT_NO_FLY } = props;
  return (
    <React.Fragment>
      {variant === VARIANT_NO_FLY ? <ZoneDetailsPopupNoFly zone={zone} /> : <ZoneDetailsPopupSafeLand zone={zone} />}
    </React.Fragment>
  );
};